skrilla.controller('abaTransactionsCtrl', function ($scope, searchService, modalService, FileSaver) {

    $scope.finaliseRequest = {}
    $scope.finalising = false;
    function getTransaction(){
        searchService.get("withdrawals/currentABA").then(function(response){
            $scope.aba = response.data;
        });
    }
    getTransaction()

    $scope.getTotalRequestedAmount = function(){
        let amount = 0;
        if($scope.aba){
            $scope.aba.withdrawals.forEach(function(withdrawal){
                amount += withdrawal.requestedAmount;
            });
        }
        return amount;
    }

    $scope.startProcessing = function(){
        modalService.confirm("Are you sure you'd like to begin processing this ABA Transaction?", function(){
            searchService.put("withdrawals/currentABA/beginToProcess", {}, "ABA Transaction now set to processing").then(function(respnse){
                getTransaction();
            });
        });
    }

    $scope.finalise = function(){
        $scope.finalising = true;
        modalService.confirm("Are you sure you'd like to finalise processing this ABA Transaction?", function(){
            searchService.put("withdrawals/currentABA/finalise", $scope.finaliseRequest, "ABA Transaction now set to processing", true).then(function(respnse){
                getTransaction();
                $scope.finalising = false
            }, function(){
                $scope.finalising = false;
            });
        }, function(){
            $scope.finalising = false;
            $scope.$apply();
        });
    }
    $scope.stopProcessing = function(){
        modalService.confirm("Are you sure you'd like to stop processing this ABA Transaction?", function(){
            searchService.put("withdrawals/currentABA/stopProcessing", $scope.finaliseRequest, "ABA Transaction now set to pending").then(function(respnse){
                getTransaction();
            });
        });
    }

    $scope.generateFile = function(encodeANSI = false) {
        var totalAmount = 0;
        var arr = ["0                 01CBA       Skrilla Client Funds      301500SKRWITHD    "+ getDate() + "                                        \r\n"];
        $scope.aba.withdrawals.forEach(function(withdrawal){
            totalAmount += withdrawal.abaAmountToPay;
            arr.push("1" + getBsb(withdrawal.bankAccountBsb) + withdrawal.bankAccountNumber.toString().padEnd(9, ' ') + " 50" + withdrawal.abaAmountToPay.toString().padStart(10, '0')
                + withdrawal.bankAccountName.padEnd(32, ' ') + "Picklebet Withdraw064-170 10717180Picklebet WDL  -00000000\r\n");
        });
        arr.push("1064-17010717180  13" + totalAmount.toString().padStart(10, '0') + "Skrilla Client Funds            SKRWITHD          064-170 10717180Picklebet WDL  -00000000\r\n")
        arr.push("7999-999            0000000000" + totalAmount.toString().padStart(10, '0') + totalAmount.toString().padStart(10, '0') + "                        "
            + ($scope.aba.withdrawals.length + 1).toString().padStart(6, '0') +
            "                                        \r\n");
        console.log(arr);
        let blob;
        if (encodeANSI) {
            // Commbiz only accepts ANSI encoding, Leo is currently doing this after downloading
            // Tested downloading it like this, he said it works, but leaving 2 download options in case
            const text = arr.join('');
            // Check for characters outside the Windows-1252 range
            if ([...text].some(char => char.charCodeAt(0) > 255)) {
                alert('Warning: This file contains characters that cannot be saved in the ANSI (Windows-1252) format. Some data may be lost.');
            }
            const encoder = new TextEncoder('windows-1252');
            const uint8Array = encoder.encode(text);
            blob = new Blob([uint8Array], {type: "text/plain;charset=windows-1252"});
        } else {
            blob = new Blob(arr, {type: "text/plain;charset=utf-8"});
        }
        FileSaver.saveAs(blob, getDate() + ".aba");
    }

    function getBsb(bsbNum){
        var bsb = bsbNum.toString();
        return bsb.substring(0, 3) + "-" + bsb.substring(3, 6);
    }

    function getDate(){
        var date = new Date();
        return date.getDate().toString().padStart(2, '0') + (date.getMonth() + 1).toString().padStart(2, '0') + (date.getYear() - 100).toString();

    }

});


